import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import {
  Box,
  Button,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

function ErrorPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: 4,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 640,
          p: { xs: 3, sm: 4 },
          borderRadius: 4,
        }}
      >
        <Stack spacing={3} alignItems="flex-start">
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: "error.light",
              color: "error.contrastText",
            }}
          >
            <ErrorOutlineRoundedIcon />
          </Box>
          <Stack spacing={1}>
            <Typography variant="h5">エラーが発生しました</Typography>
            <Typography variant="body1" color="text.secondary">
              ページの表示中に問題が発生しました。
            </Typography>
          </Stack>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
            <Button
              variant="contained"
              startIcon={<HomeRoundedIcon />}
              onClick={() => navigate("/", { replace: true })}
            >
              ホームへ戻る
            </Button>
            {!isAuthenticated && (
              <Button
                variant="outlined"
                startIcon={<LoginRoundedIcon />}
                onClick={() => navigate("/login", { replace: true })}
              >
                ログイン画面へ
              </Button>
            )}
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}

export default ErrorPage;
